import React, { useState } from 'react';
import './App.css';
import Login from './components/Login';
import Signup from './components/Signup';
import Dashboard from './components/Dashboard';

function App() {
  const [currentPage, setCurrentPage] = useState('login'); // login, signup, dashboard
  const [user, setUser] = useState(null);

  const handleLoginSuccess = (userData) => {
    setUser(userData);
    setCurrentPage('dashboard');
  };

  const handleLogout = () => {
    setUser(null);
    setCurrentPage('login');
  };

  const switchToSignup = () => {
    setCurrentPage('signup');
  };

  const switchToLogin = () => {
    setCurrentPage('login');
  };

  return (
    <div className="App">
      {currentPage === 'login' && (
        <Login onLoginSuccess={handleLoginSuccess} onSwitchToSignup={switchToSignup} />
      )}
      
      {currentPage === 'signup' && (
        <Signup onSignupSuccess={switchToLogin} onSwitchToLogin={switchToLogin} />
      )}
      
      {currentPage === 'dashboard' && user && (
        <Dashboard tenantId={user.tenantId} user={user} onLogout={handleLogout} />
      )}
    </div>
  );
}

export default App;